<div class="ModuleList">
  <div class="ModuleList_Container">
    <div class="Header" *ngIf="isSuperAdmin" [ngClass]="{'BG':active_Menu=='project','selected-module':active_Menu=='project'}" (click)="onMenuClick('project')">
      <div class="menu-header_txt">{{menu_1}}</div>
    </div>
    <div class="Header" [ngClass]="{'BG':active_Menu=='user','selected-module':active_Menu=='user'}" (click)="onMenuClick('user')">
      <div class="menu-header_txt">{{menu_2}}</div>
    </div>
    <div class="Header" [ngClass]="{'BG':active_Menu=='report','selected-module':active_Menu=='report'}" (click)="onMenuClick('report')">
      <div class="menu-header_txt">{{menu_3}}</div>
    </div>
  </div>
</div>
